// extracted by mini-css-extract-plugin
module.exports = {"ErrorMessage":"ErrorMessage_ErrorMessage__3z2YZ","ErrorMessage__text":"ErrorMessage_ErrorMessage__text__Y6ivk"};